import { NavigationEnum } from "../../components/navbar/navigation.enum";

export interface ToggleNavLink {
    navLinkType: NavigationEnum;
    active: boolean;
}